export let saveButtonText = "akDwce";
export default {saveButtonText};